import React, { useRef, useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { Button, Toast } from 'antd-mobile';
import { useThrottledHandler } from 'App';
import { downloadImageStrong } from 'utils/downloadUtil';

const UserLoginCertificate = ({ title, imageUrl, username, generateTime, width, height }) => {
  const canvasRef = useRef(null);
  const qrRef = useRef(null);

  useEffect(() => {
    console.log(imageUrl, username, generateTime, width);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // 创建 Image 对象加载背景图片
    const backgroundImage = new Image();
    backgroundImage.src = imageUrl;
    backgroundImage.crossOrigin = 'anonymous'; // 允许跨域加载图片
    backgroundImage.onload = () => {
      // const targetWidth = Math.min(window.screen.availWidth, width); // 固定宽度为浏览器宽度
      // const targetHeight = backgroundImage.height * (targetWidth / backgroundImage.width);
      const targetHeight = height - 50; // 固定宽度为浏览器宽度
      const targetWidth = backgroundImage.width * (targetHeight / backgroundImage.height);
      console.log(targetWidth, targetHeight);

      // 设置 canvas 尺寸
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      // 绘制背景图片
      ctx.drawImage(backgroundImage, 0, 0, targetWidth, targetHeight);

      // 设置二维码的宽度为图片宽度的一半
      const qrWidth = targetWidth / 2 / 1.5;
      const qrCanvas = qrRef.current.querySelector('canvas');
      const qrHeight = qrCanvas.height * (qrWidth / qrCanvas.width);

      // 计算白色背景框的位置和圆角
      const padding = 25;
      const radius = 20; // 圆角半径
      const bgX = (targetWidth - qrWidth - 2 * padding) / 2;
      const bgY = (targetHeight - qrHeight - 2 * padding - 100) / 2 + 30;

      // 绘制带圆角的白色背景框并添加阴影
      ctx.fillStyle = 'white';
      ctx.shadowColor = 'rgba(255, 255, 255, 1)'; // 阴影颜色
      ctx.shadowBlur = 50; // 阴影模糊度
      ctx.shadowOffsetX = 0; // 阴影X偏移
      ctx.shadowOffsetY = 0; // 阴影Y偏移
      ctx.beginPath();
      ctx.moveTo(bgX + radius, bgY);
      ctx.arcTo(
        bgX + qrWidth + 2 * padding,
        bgY,
        bgX + qrWidth + 2 * padding,
        bgY + qrHeight + 2 * padding + 50,
        radius
      );
      ctx.arcTo(
        bgX + qrWidth + 2 * padding,
        bgY + qrHeight + 2 * padding + 50,
        bgX,
        bgY + qrHeight + 2 * padding + 50,
        radius
      );
      ctx.arcTo(bgX, bgY + qrHeight + 2 * padding + 50, bgX, bgY, radius);
      ctx.arcTo(bgX, bgY, bgX + qrWidth + 2 * padding, bgY, radius);
      ctx.closePath();
      ctx.fill();

      // 绘制 "登录凭证" 文字
      ctx.font = '14px Shuhei';
      ctx.fillStyle = '#f66';
      ctx.textAlign = 'center';
      ctx.fillText(title + ' 登录凭证', targetWidth / 2, bgY + padding);

      // 绘制二维码到背景框中
      ctx.shadowColor = 'rgba(0, 0, 0, 0.2)'; // 阴影颜色
      ctx.shadowBlur = 15; // 阴影模糊度
      ctx.shadowOffsetX = 0; // 阴影X偏移
      ctx.shadowOffsetY = 8; // 阴影Y偏移
      ctx.drawImage(qrCanvas, bgX + padding, bgY + padding + 15, qrWidth, qrHeight);

      // 设置文字样式
      ctx.font = '12px Shuhei';
      ctx.fillStyle = '#333';
      ctx.textAlign = 'center';

      // 绘制用户名
      ctx.fillText(username, targetWidth / 2, bgY + qrHeight + 2 * padding + 13);

      // 绘制生成时间
      ctx.font = '11px Shuhei';
      ctx.fillText(generateTime, targetWidth / 2, bgY + qrHeight + 2 * padding + 30);
    };
  }, [imageUrl, username, generateTime, width]);

  return (
    <div>
      {/* 隐藏的 QRCodeCanvas 元素 */}
      <div
        ref={qrRef}
        style={{ display: 'none' }}
      >
        <QRCodeCanvas
          value={username.qrValue}
          size={200}
        />
      </div>
      {/* 绘制结果的 Canvas 元素 */}
      <canvas
        ref={canvasRef}
        className=" rounded-md shadow-md"
      />
      <div className=" flex justify-center items-center mt-3 mb-2">
        <Button
          className=""
          color="primary"
          onClick={useThrottledHandler(() => {
            const imageUrl = canvasRef.current.toDataURL('image/png');
            const imageName = '【uutt.me】用户登录凭证.png';
            downloadImageStrong({ imageUrl, imageName });
          })}
        >
          导出登录凭证
        </Button>
      </div>
    </div>
  );
};

export default UserLoginCertificate;
